import { useMemo } from 'react';

import type { ListingSettings, Site } from '@r6digital/rapidstor-sdk/domain';
import type Location from '@r6digital/rapidstor-types/react/entities/Location';

import { siteFor } from './context';

/**
 * Memoises the SDK {@link Site} wrapper for a location, so its settings facades are reachable from
 * components without rebuilding the wrapper on every render.
 *
 * @param location - The friendly location entity.
 * @returns The `Site` wrapper.
 */
export const useSite = (location: Location): Site => useMemo(() => siteFor(location), [location]);

/**
 * Memoises the site's listing settings — the group most components in this screen read.
 *
 * @param location - The friendly location entity.
 * @returns The listing settings accessors.
 */
export const useListingSettings = (location: Location): ListingSettings => {
    const site = useSite(location);
    return useMemo(() => site.settings.listing(), [site]);
};
